export default __webpack_public_path__ + "static/media/vip-icon.bef55cff.svg";